var map = {
	"./american-truck-simulator.jpg": 5125,
	"./assetto-corsa.jpg": 9141,
	"./beamng-drive.jpg": 4007,
	"./city-car-driving.jpg": 70,
	"./euro-truck-simulator-2.jpg": 775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1476;